import styled from "styled-components";
import Chip from "@mui/material/Chip";

export const StyledChip = styled(Chip)`
  &.MuiChip-root {
    min-width: 80px;
    &.MuiChip-colorWarning {
      background-color: #ffd80033;
      border: 1px solid #faa400;
      color: #faa400;
      border-radius: 5px;
    }
    &.MuiChip-colorSuccess {
      background-color: #73d60033;
      border: 1px solid #67ce00;
      color: #67ce00;
      border-radius: 5px;
    }
    &.MuiChip-colorError {
      background-color: #ff000026;
      border: 1px solid #d60000;
      color: #d60000;
      border-radius: 5px;
    }
  }
`;
